import * as types from "./type";

const initialState = {
  data: [],
  dataList: [],
  dataCall:[],
  loading: false,
  editLoad: false,
};

export const reportReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_REPORTS:
      return {
        ...state,
        ...{ loading: true },
      };

    case types.GET_REPORTS_SUCCESS:
      return {
        ...state,
        ...{
          dataList: action.payload,
          loading: false,
        },
      };

    case types.GET_REPORTS_FAIL: {
      return {
        ...state,
        ...{ dataList: [], loading: false },
      };
    }
    case types.GET_REPORT_CALL:
      return {
        ...state,
        ...{ loading: true },
      };

    case types.GET_REPORT_CALL_SUCCESS:
      return {
        ...state,
        ...{
          dataCall: action.payload,
          loading: false,
        },
      };

    case types.GET_REPORT_CALL_FAIL: {
      return {
        ...state,
        ...{ dataCall: [], loading: false },
      };
    }
    case types.RESET_MESSAGE_ERROR:
      return {
        ...state,
        loading: false,
        data: [],
      };

    default:
      return state;
  }
};
